import {
  QUERIES,
  WithChildren,
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
} from '../../../../../../_metronic/helpers'
import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import { Importacao } from './_models'
import { getImportacoes } from './_requests'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<Importacao>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.IMPORTACOES_LIST, query, isOpen], () => getImportacoes(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
